import { useSelector } from "react-redux";

import { getIntegrationCredentialById } from "selectors/integrationCredentials";

interface XeroDeepLinkOptions {
  credentialsId: string;
  contactId?: string;
  documentId?: string;
}

export function useXeroDeepLink({
  credentialsId,
  contactId,
  documentId,
}: XeroDeepLinkOptions): string | null {
  const credential = useSelector(getIntegrationCredentialById(credentialsId));
  const shortCode = credential?.organizationShortCode;

  if (!shortCode) {
    return null;
  }

  if (contactId) {
    return `https://go.xero.com/app/${shortCode}/contacts/contact/${contactId}`;
  }

  if (documentId) {
    return `https://go.xero.com/app/${shortCode}/invoices/${documentId}`;
  }

  return null;
}
